<template>
  <div :class="['news-block', alignmentClass]">
    <p class="text-sm mb-0">News</p>
    <div class="border-top border-dark pt-3">
      <p class="text-xl-max">{{ heading }}</p>
      <div v-html="text"></div>
  
      <a
        v-if="linkUrl"
        :href="linkUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="btn-icon-right mt-2"
      ></a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  heading: { type: String, required: true },
  text: { type: String, required: true },
  alignment: { type: String, default: 'left' },
  linkUrl: { type: String, default: null }
})

const alignmentClass = computed(() => {
  if (props.alignment === 'right') return 'col-12 col-sm-6 offset-sm-6'
  return 'col-12 col-sm-6'
})
</script>